import { useDidUpdateEffect } from 'client/utils/use-did-update-effect';
import { makeUndoRedo, on } from 'minidoc-editor';
import { useEffect, useMemo } from 'preact/hooks';

export function useUndoRedo<T>(state: T, setState: (state: T) => void) {
  const undoRedo = useMemo(() => {
    const result: ReturnType<typeof makeUndoRedo<T>> & { locked?: boolean } = makeUndoRedo({
      initialState: state,
      setState(value) {
        result.locked = true;
        setState(value);
      },
    });

    return result;
  }, [setState]);

  useDidUpdateEffect(() => {
    if (undoRedo.locked) {
      undoRedo.locked = false;
    } else {
      undoRedo.push(state);
    }
  }, [state]);

  useEffect(
    () =>
      on(document, 'keydown', (e: KeyboardEvent) => {
        if (e.defaultPrevented) {
          return;
        }
        const isCtrl = e.metaKey || e.ctrlKey;
        const isRedo = isCtrl && e.shiftKey && e.code === 'KeyZ';
        const isUndo = isCtrl && e.code === 'KeyZ';
        if (!isRedo && !isUndo) {
          return;
        }
        e.preventDefault();
        isRedo ? undoRedo.redo() : undoRedo.undo();
      }),
    [undoRedo],
  );

  return undoRedo;
}
